import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LEGACY = ["ig_access", "ig_refresh"];
// Sessions live only in httpOnly cookies; drop tokens older builds kept in storage.
LEGACY.forEach((k) => localStorage.removeItem(k));

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
export async function refreshAccess() {
  if (!refreshing) {
    refreshing = axios
      .post(`${API}/auth/refresh`, null, { withCredentials: true })
      .finally(() => {
        refreshing = null;
      });
  }
  return refreshing;
}

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    const url = cfg?.url || "";
    if (err.response?.status === 402 && window.location.pathname !== "/subscribe") {
      window.location.assign("/subscribe");
    }
    if (err.response?.status === 401 && !cfg._retry && !url.includes("/auth/login") && !url.includes("/auth/refresh")) {
      cfg._retry = true;
      try {
        await refreshAccess();
        return api(cfg);
      } catch (e) {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const errMsg = (e) => (e?.response || !e?.message ? formatApiErrorDetail(e?.response?.data?.detail) : e.message);

export async function streamMessage(cid, payload, onEvent) {
  const send = () =>
    fetch(`${API}/consultations/${cid}/messages`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
  let res = await send();
  if (res.status === 401) {
    await refreshAccess();
    res = await send();
  }
  if (res.status === 402) window.location.assign("/subscribe");
  if (!res.ok) {
    let detail;
    try {
      detail = (await res.json()).detail;
    } catch (e) {
      detail = null;
    }
    throw new Error(formatApiErrorDetail(detail));
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      const line = p.split("\n").find((l) => l.startsWith("data: "));
      if (!line) continue;
      try {
        onEvent(JSON.parse(line.slice(6)));
      } catch (e) {
        console.warn("Skipped malformed stream frame", e);
      }
    }
  }
}
